define(["require", "exports", "tslib", "mobx", "mobx-react", "react", "react-router", "../components/blocks", "../constants", "../model/services/EventManager", "../utils/RouteUtil", "./Events"], function (require, exports, tslib_1, mobx_1, mobx_react_1, React, react_router_1, blocks_1, constants_1, EventManager_1, RouteUtil_1, Events_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DebugRoute = exports.openRoute = exports.RouteStore = exports.RegisterHistory = void 0;
    React = tslib_1.__importStar(React);
    let history = null;
    function RegisterHistory() {
        if (!history) {
            history = (0, react_router_1.useHistory)();
            openRoute({ pathname: (0, react_router_1.useLocation)().pathname });
        }
        return null;
    }
    exports.RegisterHistory = RegisterHistory;
    class RouteStore {
        get IsEntityRouteActive() {
            return (0, RouteUtil_1.isEntityRoute)(this.route);
        }
        get IsEntityCreateRouteActive() {
            return (0, RouteUtil_1.isEntityCreateRoute)(this.route);
        }
        constructor(storeManager) {
            Object.defineProperty(this, "storeManager", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "entityRoute", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "route", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.storeManager = storeManager;
            window.openRoute = (route) => {
                openRoute({ pathname: route });
            };
            EventManager_1.EventManager.Instance.on(Events_1.ROUTE_PUSH_EVENT, (route) => {
                console.log(Events_1.ROUTE_PUSH_EVENT, route, history);
                if (!route.pathname) {
                    console.error(Events_1.ROUTE_PUSH_EVENT, "No path provided");
                    return;
                }
                this.route = route.pathname;
                pushRoute(route);
            });
            EventManager_1.EventManager.Instance.on(Events_1.ROUTE_ENTER_EVENT, (path) => {
                console.log(`${Events_1.ROUTE_ENTER_EVENT} ${path}`);
                this.route = path;
                if ((0, RouteUtil_1.isEntityRoute)(this.route) && !(0, RouteUtil_1.isEntityRoute)(this.entityRoute)) {
                    console.warn("Fixed entity route");
                    this.entityRoute = this.route;
                }
                if ((0, RouteUtil_1.isEntityCreateRoute)(this.route) && !(0, RouteUtil_1.isEntityCreateRoute)(this.entityRoute)) {
                    console.warn("Fixed entity route (create)");
                    this.entityRoute = this.route;
                }
            });
            EventManager_1.EventManager.Instance.on(Events_1.ENTITY_OPENED_EVENT, () => {
                console.log(`${Events_1.ENTITY_OPENED_EVENT} ${this.route}`);
                this.entityRoute = this.route;
            });
            EventManager_1.EventManager.Instance.on(Events_1.ENTITY_CLOSED_EVENT, () => {
                console.log(`${Events_1.ENTITY_CLOSED_EVENT} ${this.route}. entityRoute = null`);
                this.entityRoute = null;
            });
            EventManager_1.EventManager.Instance.on(Events_1.SERVICE_REQUEST_ERROR, (url, err) => {
                if ((err === null || err === void 0 ? void 0 : err.Code) == 401) {
                    console.log(`${Events_1.SERVICE_REQUEST_ERROR}. 401`);
                    openRoute({ pathname: constants_1.ROUTE_LOGIN });
                }
            });
        }
    }
    exports.RouteStore = RouteStore;
    tslib_1.__decorate([
        mobx_1.observable
    ], RouteStore.prototype, "entityRoute", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], RouteStore.prototype, "route", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], RouteStore.prototype, "IsEntityRouteActive", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], RouteStore.prototype, "IsEntityCreateRouteActive", null);
    function openRoute(route) {
        EventManager_1.EventManager.Instance.emit(Events_1.ROUTE_PUSH_EVENT, route);
    }
    exports.openRoute = openRoute;
    const pushRoute = (route) => {
        if (route.pathname) {
            if (route.type == "replace") {
                history.replace(route.pathname, route.state);
            }
            else {
                history.push(route.pathname, route.state);
            }
        }
    };
    exports.DebugRoute = (0, mobx_react_1.observer)((props) => {
        const { store } = props;
        const { entityRoute, route } = store;
        const colour = route == entityRoute ? "cyan" : "hotpink";
        return React.createElement(blocks_1.VGroup, { style: { position: "fixed", left: 10, bottom: 10, zIndex: 99999, backgroundColor: "rgba(0,0,0,0.5)", color: colour, padding: 10, pointerEvents: "none" } },
            React.createElement("div", null,
                "Route ",
                route),
            React.createElement("div", null,
                "Entity Route: ",
                entityRoute),
            React.createElement("div", null,
                "isEntityCreateRoute: ",
                (0, RouteUtil_1.isEntityCreateRoute)(route) ? "true" : "false"),
            React.createElement("div", null,
                "isEntityRoute: ",
                (0, RouteUtil_1.isEntityRoute)(route) ? "true" : "false"));
    });
});
